import OverlayTips from "../OverlayTips";

function ApproveTTPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

ApproveTTPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle"), {
            messageKey: "tips.approve_tt.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -100,
                offsetY: 5
            }
        });

        this.add($(".ttaHistoryIcon"), {
            messageKey: "tips.approve_tt.history",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: -10
        });

        this.add($("#rejectButton"), {
            messageKey: "tips.approve_tt.approve_reject",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -10,
            offsetY: 5
        });

        this.add(function() { return $(".data .groupingRow").not(".operationWasApplied").children(".selectionCell").eqOrLast(1)}, {
            messageKey: "tips.approve_tt.choose_timesheets",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetY: -10
        });
    }
});

export default ApproveTTPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/ApproveTTPageOverlayTipsManager.js